import { createRouter, createWebHistory } from "vue-router";
import { $http } from "@/boot/http";
import store from "@/store";
import moment from "moment";
import _ from "lodash";
import EmployeeProfileRoutes from "./EmployeeProfileRoutes";
import SystemSetupRoutes from "./SystemSetupRoutes";
import ReportRoutes from "./ReportRoutes";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/views/pages/Page404.vue')
    },
    {
      path: '/403',
      component: () => import('@/views/pages/Page404.vue')
    },
    {
      path: "/",
      component: () => import('@/views/Layout.vue'),
      children: [
        {
            name: 'home',
            path: '/home',
            component: () => import('@/views/HomeView.vue')
        },
        {
          name: 'profile',
          path: '/profile',
          component: () => import('@/views/Profile.vue')
        }
      ]
    },
    {
      name: "login",
      path: "/login",
      component: () => import('@/views/Login.vue'),
    },
    { 
      name: "logout",
      path: "/logout",
      component: {
        async beforeRouteEnter(to, from, next) {
          await $http.post(`api/auth/logout`)
          store.dispatch('setLogout')
          next('/login')
          next()
        }
      }
    },
    EmployeeProfileRoutes,
    ReportRoutes,
    SystemSetupRoutes
  ],
});

router.beforeResolve(async (to, from, next) => {
  if (['/login', '/logout'].indexOf(to.path) == -1) {
    const { isAutherized, tokenExpire } = store.state
    const currentDate = moment()
    if (!isAutherized) {
      next('/login')
    } else {
      if (tokenExpire == null) {
        next('/login')
      }
      if (currentDate.isAfter(tokenExpire)) {
        $http.post('/api/auth/token', { refreshToken: store.state.refreshToken })
          .then((tokenRes:any) => {            
            if (tokenRes != null && tokenRes.status === 200) {
              store.dispatch('setTokenKey', tokenRes.data)
            } else {
              store.dispatch('setIsAutherized', false)
              next('/login')
            }
          })
      }
    }

    const { permissions } = to.meta
    if (!permissions) {
      next()
    } else {
      if (_.intersection(store.state.permissions, String(permissions).split(',')).length > 0) {
        next()
      } else {
        next({ path: '/403', replace: true })
      }
    }
  }
  next()
});

export default router;